import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompLights({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] =useState('Guardar Informacion')
  const [infoLightComp, setInfoCompLight] = useState({
    high: 0,
    Stockings: 0,
    Low: 0,
    Directional: 0,
    Parking_lot: 0,
    Brake: 0,
    reverse: 0,
    License_plate: 0,
    Third_Stop: 0,
    Explorers: 0,
    The_ceiling: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'LC', data: infoLightComp });
  });

  const handleForm = ({ target }) => {
    const tmpLigthComp = { ...infoLightComp, [target.name]: target.value }
    setInfoCompLight(tmpLigthComp);
    autosave.schedule();
    //generalUpdate('infoLightComp', tmpLigthComp)
  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get( `/peritaje/infostate/C` ,  {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data;
      const currentDefaultState = stateapp.find((e)=> e.name.toLowerCase()==='bueno')
      setInfoCompLight({
        high: currentDefaultState.id,
        Stockings: currentDefaultState.id,
        Low: currentDefaultState.id,
        Directional: currentDefaultState.id,
        Parking_lot: currentDefaultState.id,
        Brake: currentDefaultState.id,
        reverse: currentDefaultState.id,
        License_plate: currentDefaultState.id,
        Third_Stop: currentDefaultState.id,
        Explorers: currentDefaultState.id,
        The_ceiling: currentDefaultState.id,
      });
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = {type:'LC', data :infoLightComp};
    const respo = await post('/peritaje/modifyinspection/components/'+id, body);
    if(respo.success){
      setMsgButton('Actualizar')
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'LC' };
      const tmpLigth = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const {detail} = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpLigth[element.name] = element.id_state;
        }
        if(detail.length>0) setInfoCompLight(tmpLigth);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner />  : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">LUMINARIAS</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="high">Altas</Form.Label>
          <Form.Select
            name="high"
            value={infoLightComp.high}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Stockings">Medias</Form.Label>
          <Form.Select
            name="Stockings"
            value={infoLightComp.Stockings}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Low">Bajas</Form.Label>
          <Form.Select
            name="Low"
            value={infoLightComp.Low}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Directional">Direccionales</Form.Label>
          <Form.Select
            name="Directional"
            value={infoLightComp.Directional}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Parking_lot">Estacionamiento</Form.Label>
          <Form.Select
            name="Parking_lot"
            value={infoLightComp.Parking_lot}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Brake">Freno</Form.Label>
          <Form.Select
            name="Brake"
            value={infoLightComp.Brake}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="reverse">Reversa</Form.Label>
          <Form.Select
            name="reverse"
            value={infoLightComp.reverse}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="License_plate">Placa</Form.Label>
          <Form.Select
            name="License_plate"
            value={infoLightComp.License_plate}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Third_Stop">Tercer Stop</Form.Label>
          <Form.Select
            name="Third_Stop"
            value={infoLightComp.Third_Stop}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Explorers">Exploradoras</Form.Label>
          <Form.Select
            name="Explorers"
            value={infoLightComp.Explorers}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="The_ceiling">Techo</Form.Label>
          <Form.Select
            name="The_ceiling"
            value={infoLightComp.The_ceiling}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
          {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompLights;
